import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useLoadingStore = defineStore('loading', () => {
    const count = ref(0)            // 동시에 여러 요청 발생 시 누적
    const message = ref('')         // 필요 시 메시지 표시
    const since = ref(0)            // 보여주기 시작한 시각(ms)

    const visible = computed(() => count.value > 0)
    const isLoading = computed(() => visible.value)

    // flicker 방지 옵션
    const MIN_DURATION = 300        // 최소 노출(ms)
    const DELAY = 120               // 늦게 나타나기(ms) – 아주 짧은 요청은 안보이게

    let delayTimer = null

    function show(msg = '') {
        message.value = msg || message.value
        // delay 후 카운트 증가
        if (count.value === 0) {
            clearTimeout(delayTimer)
            delayTimer = setTimeout(() => {
                count.value += 1
                since.value = Date.now()
            }, DELAY)
        } else {
            count.value += 1
        }
    }

    function hide() {
        // delay 타이머만 있는 상태에서 hide 요청 들어오면 타이머 제거
        if (count.value === 0 && delayTimer) {
            clearTimeout(delayTimer)
            delayTimer = null
            return
        }
        // 최소 노출 시간 보장
        const remain = MIN_DURATION - (Date.now() - since.value)
        if (remain > 0 && count.value === 1) {
            setTimeout(() => { count.value = 0 }, remain)
        } else {
            count.value = Math.max(0, count.value - 1)
        }
    }

    // 편의: 비동기 함수 감싸기
    async function withLoading(promiseOrFn, msg = '') {
        // If no message is provided, use default 'Loading...'
        const loadingMsg = msg || 'Loading...'
        show(loadingMsg)
        const p = typeof promiseOrFn === 'function' ? promiseOrFn() : promiseOrFn
        return await p.finally(() => {hide()})
    }

    // 강제 리셋(예외 대비)
    function reset() {
        clearTimeout(delayTimer)
        delayTimer = null
        count.value = 0
        message.value = ''
    }

    return { visible, isLoading, message, show, hide, withLoading, reset }
})